import { createActions } from '../../../utils/index.js';

export const recommendationsActions = createActions('GET_RECOMMENDATIONS');

export const recommendationsStateActions = createActions(
  'GET_RECOMMENDATIONS_STATE',
);

export const recommendationActions = createActions('GET_RECOMMENDATION');

export const acceptRecommendationActions = createActions(
  'ACCEPT_RECOMMENDATION',
);

export const rejectRecommendationActions = createActions(
  'REJECT_RECOMMENDATION',
);

export const getRecommendationsSettingsActions = createActions(
  'GET_RECOMMENDATIONS_SETTINGS',
);

export const changeRecommendationsSettingsActions = createActions(
  'CHANGE_RECOMMENDATIONS_SETTINGS',
);

export const recommendationsActionsGoal = createActions(
  'GET_RECOMMENDATIONS_GOAL',
);

export const publishRecommendationActions = createActions(
  'PUBLISH_RECOMMENDATION',
);
